import { ENV } from "../utils";

export class StrategicAxis {
  baseApi = ENV.BASE_API;

  /**
   * Crear nuevo eje estratégico
   */
  async createAxis(accessToken, data) {
    try {
      const url = `${this.baseApi}/strategic-axis`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener todos los ejes estratégicos
   */
  async getAllAxes(accessToken, active = true) {
    try {
      const url = `${this.baseApi}/strategic-axis?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener eje estratégico por ID
   */
  async getAxisById(accessToken, id) {
    try {
      const url = `${this.baseApi}/strategic-axis/${id}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Obtener ejes estratégicos por sitio
   */
  async getAxesBySite(accessToken, siteId, active = true) {
    try {
      const url = `${this.baseApi}/strategic-axis/site/${siteId}?active=${active}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Actualizar eje estratégico
   */
  async updateAxis(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/strategic-axis/${id}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Eliminar eje estratégico (soft delete)
   */
  async deleteAxis(accessToken, id) {
    try {
      const url = `${this.baseApi}/strategic-axis/${id}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Inicializar ejes estratégicos por defecto para un sitio
   */
  async initializeDefaultAxes(accessToken, siteId) {
    try {
      const url = `${this.baseApi}/strategic-axis/initialize/${siteId}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
